import React, { FormEvent } from 'react';
import { Button, Checkbox, FormControlLabel, IconButton, InputAdornment, TextField, styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { UsersQueryParams } from './hooks/useFetchUsers';
import FilterBox from 'components/filter-box/FilterBox';
import CpfInput from 'components/masked-input/CpfInput';
import { asInputComponent } from 'components/masked-input/asInputComponent';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '300px 200px 100px 100px',
  columnGap: 10,
  rowGap: 15,
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type UsersFilterBoxProps = {
  filter: UsersQueryParams;
  handleChange(index: keyof UsersQueryParams, value: any): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const UsersFilterBox: React.FC<UsersFilterBoxProps> = ({ filter, loading, handleChange, handleSearch }) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          fullWidth
          label="Nome do usuário"
          placeholder="Digite o nome do usuário"
          value={filter.name}
          autoFocus
          onChange={e => handleChange('name', e.target.value)}
        />

        <TextField
          fullWidth
          label="CPF"
          placeholder="Digite o CPF"
          value={filter.document_number}
          onChange={e => handleChange('document_number', e.target.value)}
          slotProps={{
            input: {
              inputComponent: asInputComponent(CpfInput),
            },
          }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={filter.active}
              onChange={e => handleChange('active', e.target.checked)}
              color="primary"
            />
          }
          label="Ativos"
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default UsersFilterBox;
